<template>
  <div class="card-content details">
    <div class="is-pulled-left">
      <logo-societe :societeId="commande.destinataire.tiersId"></logo-societe>
    </div>
    <div class="reference">
      <strong>{{ commande.generalInfos.titleType  }} {{ commandeDetail.code }}</strong>
      <p>{{ commande.generalInfos.theme }}</p>
      <span>{{ commande.generalInfos.dateDevisCommande }}</span>
    </div>
    <div class="intervenant is-flex"
         :class="{'is-spaced-between': commercial}">
      <div>
        <div v-if="commande.referenceClient">
          {{ $t('detailCommandeBailleur.referenceFournisseur',
          { referenceFournisseur: commande.referenceClient }) }}
        </div>
        <infos-commercial v-if="commercial"
          :commercial="commercial"
          :reference-client="commande.referenceClient"
          :code-dossier="commande.codeDossier"/>
      </div>
      <div class="has-text-right"
           :class="{'pull-right': !commercial}">
        <div v-if="mentionMandataire">
          {{ commande.destinataire.titre ? commande.destinataire.titre
          : commande.destinataire.libelle }}
        </div>
        <div class="columns is-marginless">
          <div class="column is-paddingless"></div>
          <router-link-blank
            class="column is-narrow is-paddingless"
            :to="{
              name: 'c.baux.bailleur',
              params: { id: commande.destinataire.tiersId }
            }"
            :message=" commande.destinataire.adressePostale.intitule1
              ? commande.destinataire.adressePostale.intitule1
              : commande.destinataire.nomCommercial"/>
        </div>
        <div>
          {{ commande.destinataire.adressePostale.intitule2 }}
          <span v-if="mentionMandataire">
            {{ commande.destinataire.adressePostale.intitule3 }}
          </span>
        </div>
        <div v-if="!mentionMandataire">
          {{ commande.destinataire.adressePostale.intitule3 }}
        </div>
        <div>
          {{ commande.destinataire.adressePostale.adresse1 }}
        </div>
        <div>
          {{ commande.destinataire.adressePostale.adresse2 }}
        </div>
        <div>
          {{ commande.destinataire.adressePostale.adresse3 }}
        </div>
        <div>
          <span v-if="commande.destinataire.adressePostale.codePostal">
          {{ $t('detail.codePostal', {
            codePostal: commande.destinataire.adressePostale.codePostal}) }}
          </span>
          {{ commande.destinataire.adressePostale.ville }}</div>
        <div> {{ commande.destinataire.adressePostale.pays }}</div>
        <div v-if="commande.destinataire">
          <span v-if="commande.destinataire.tiers && commande.destinataire.tiers.siret">
            {{ $t('detailCommandeBailleur.clients.siretClient',
             { siret: commande.destinataire.tiers.siret } )}}
          </span>
          <span v-else>{{ $t('detailCommandeBailleur.clients.siretDefault')}}</span>
          <multi-contact-intervenant :intervenant="commande.destinataire"/>
        </div>
      </div>
    </div>
    <infos-intervenant :intervenants="commande.intervenants"/>
    <br>
    <small>
      <router-link-blank :to="{name: 'c.baux.contrat',
          params: {id: commandeDetail.referenceExterne }}"
        :message="$t('detail.commande.referenceContrat',
          { codeDossier: commandeDetail.codeDossier })"
      />
    </small>
    <detail-lignes-commande
      :referencesCommandes="commandeDetail.references"
      :masqueRemise="commandeDetail.masqueRemise"
      :isEditPrevisu="isEditPrevisu"
      :isPrevisualisation="isPrevisualisation"
      :typeDCF="constantes.TYPE_COMMANDE"
      :sens="commandeDetail.sens"
      :lignes-commande="commande.lignesCommande"
      @masqueLigneChange="$emit('masqueLigneChange', $event)"
      @masqueRemiseChange="$emit('masqueRemiseChange', $event)"/>
    <div class="summary-container">
      <div class="column is-4 is-paddingless">
        <repartitions-tva
          v-if="commandeDetail.montantTva !== 0"
          :repartitions-tva="commande.repartitionsTva"/>
      </div>
      <div class="column is-paddingless">
        <div class="column is-6 is-paddingless pull-right">
          <recapitulatif-montants
            :recapitulatif="commande.recapitulatifMontants"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import RecapitulatifMontants from '@/components/devisCommandes/detailDevisCommande/recapitulatifMontants';
import { TYPE_COMMANDE } from '@/configuration/devisConf';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import RepartitionsTva from '@/components/devisCommandes/detailDevisCommande/repartitionsTva';
import InfosIntervenant from '@/components/devisCommandes/detailDevisCommande/infosIntervenant';
import DetailLignesCommande from '@/components/devisCommandes/detailDevisCommande/detailLignesCommande';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import logoSociete from '@/components/general/logoSociete';
import InfosCommercial from '@/components/devisCommandes/detailDevisCommande/infosCommercial';
import multiContactIntervenant from '@/components/devisCommandeFacture/multicontact/multiContactIntervenant';
import { get as getTiers } from '@/api/tiers/index';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    commande: {
      type: Object,
      required: true,
    },
    commandeDetail: {
      type: Object,
      required: true,
    },
    isEditPrevisu: {
      type: Boolean,
      required: false,
    },
    isPrevisualisation: {
      type: Boolean,
      required: false,
    },
    isEdit: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      constantes: {
        TYPE_COMMANDE,
      },
      logo: null,
    };
  },
  components: {
    RecapitulatifMontants,
    RepartitionsTva,
    DetailLignesCommande,
    InfosIntervenant,
    routerLinkBlank,
    logoSociete,
    InfosCommercial,
    multiContactIntervenant,
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      logoAgences: 'logoAgences',
    }),
    commercial() {
      if (this.commande.generalInfos && this.commande.generalInfos.commercial
        && this.commande.generalInfos.commercial.nom) return this.commande.generalInfos.commercial;
      return null;
    },
    mentionMandataire() {
      return (this.parametresInterne(PARAMETRES_INTERNE_KEYS.mentionMandataire.key)
        && this.commande.destinataire.mandataire);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.mentionMandataire.key]);
      if (this.commandeDetail.agenceId) {
        const logoAgence = this.logoAgences.find(logo => {
          return logo.elementId === this.commandeDetail.agenceId;
        });
        this.logo = logoAgence ? (logoAgence.cheminMin || logoAgence.chemin) : null;
      }
      if (!this.commande.destinataire) {
        this.commande.destinataire = this.commande.payeurs[0];
      }
      if (!this.commande.destinataire.tiers) {
        const tiers = await getTiers(this.commande.destinataire.tiersId);
        this.commande.destinataire.tiers = tiers.data.result;
      }
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};

</script>
